/*
 * File: confirm-response.ts
 * File Created: 2024-01-08 05:10:12
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-13 02:44:37
 * Modified By: Val Liu
 * -----
 */

import { Component, Prop } from "vue-property-decorator";
import AlertResponse from "../alert-response/alert-response";

@Component
export default class ConfirmResponse extends AlertResponse {
    @Prop({ type: Object, required: false })
    declare data: IConfirmResponseData;

    get mergedData() {
        return {
            ...defaultData,
            ...(this.data as any),
        };
    }
}

export interface IConfirmResponseData {
    "text-cancel"?: string;
    "text-submit"?: string;
}

const defaultData: IConfirmResponseData = {
    "text-cancel": "w_Cancel",
    "text-submit": "w_Submit",
};
